import { useReducer, useCallback } from 'react';

import { updateTagsRecommendationsAction, updateManualVisibilityUpdateStatusAction } from 'actions/addPost';
import {
  tagRecommendations as tagRecommendationsReducer,
  addPostVisibilityMeta as addPostVisibilityMetaReducer,
} from 'reducers/addPost';

export function useTagRecommendations() {
  const [recommendations, dispatch] = useReducer(tagRecommendationsReducer, []);
  function updateTags(tags) {
    dispatch(updateTagsRecommendationsAction(tags));
  }
  return { recommendations, updateTags };
}

export function useVisibilityManuallyUpdated() {
  const [visibilityManuallyUpdated, dispatch] = useReducer(addPostVisibilityMetaReducer, false);
  const updateVisibilityManuallyStatus = useCallback((status) => {
    dispatch(updateManualVisibilityUpdateStatusAction(status));
  }, []);
  return { visibilityManuallyUpdated, updateVisibilityManuallyStatus };
}

export function usePostClickState() {}
